import { z } from 'zod';
import { constructionStageSchema } from './stages';

export const mediaKindSchema = z.enum(['photo', 'video']);
export type MediaKind = z.infer<typeof mediaKindSchema>;

export const journalMediaSchema = z.object({
  id: z.string().uuid(),
  entryId: z.string().uuid(),
  kind: mediaKindSchema,
  storagePath: z.string(),
  publicUrl: z.string().url(),
  thumbnailUrl: z.string().url().nullable(),
  blurHash: z.string().nullable(),
  width: z.number().int().positive().nullable(),
  height: z.number().int().positive().nullable(),
  durationSeconds: z.number().positive().nullable(),
  caption: z.string().nullable(),
  takenAt: z.string().datetime().nullable(),
  sortOrder: z.number().int().nonnegative(),
  createdAt: z.string().datetime(),
});
export type JournalMedia = z.infer<typeof journalMediaSchema>;

export const weatherSchema = z.object({
  condition: z.string(),
  tempC: z.number().nullable(),
  humidity: z.number().min(0).max(100).nullable(),
});
export type Weather = z.infer<typeof weatherSchema>;

export const journalEntrySchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  entryDate: z.string().date(),
  title: z.string().min(1).max(140),
  description: z.string(),
  stage: constructionStageSchema,
  room: z.string().nullable(),
  weather: weatherSchema.nullable(),
  workers: z.array(z.string()).default([]),
  materials: z.array(z.string()).default([]),
  notes: z.string().nullable(),
  isMilestone: z.boolean().default(false),
  heroMediaId: z.string().uuid().nullable(),
  sortOrder: z.number().int().default(0),
  media: z.array(journalMediaSchema).default([]),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type JournalEntry = z.infer<typeof journalEntrySchema>;

export const journalEntryCreateSchema = journalEntrySchema
  .omit({
    id: true,
    userId: true,
    media: true,
    heroMediaId: true,
    sortOrder: true,
    createdAt: true,
    updatedAt: true,
  })
  .extend({
    mediaIds: z.array(z.string().uuid()).default([]),
  });
export type JournalEntryCreate = z.infer<typeof journalEntryCreateSchema>;

export const journalEntryUpdateSchema = journalEntryCreateSchema.partial();
export type JournalEntryUpdate = z.infer<typeof journalEntryUpdateSchema>;

export const journalFiltersSchema = z.object({
  stage: constructionStageSchema.optional(),
  month: z.number().int().min(1).max(12).optional(),
  year: z.number().int().min(2000).max(2100).optional(),
  room: z.string().optional(),
  mediaKind: mediaKindSchema.optional(),
  search: z.string().optional(),
  cursor: z.string().optional(),
  limit: z.number().int().min(1).max(100).default(24),
});
export type JournalFilters = z.infer<typeof journalFiltersSchema>;
